<template>
  <div class="panel-filters">
    <mobile-multiselect-item
      @click.native="$emit('select', 'sort')"
      title="Сортировать"
    >
      <div class="panel-filters__item-value">
        {{ sortTitle }}
      </div>
    </mobile-multiselect-item>

    <mobile-multiselect-item
      class="panel-filters__item"
      v-for="filter in filters"
      :key="filter.id"
      :title="filter.name"
      @click.native="$emit('select', filter.id)"
    >
      <ui-badge
        v-if="isCount(filter.id)"
        :text="getFilterValue(filter.id).length"
      />
      <div
        v-else
        class="panel-filters__item-value"
      >
        <template v-if="isPrice(filter.id)">
          от
          <price :value="priceValue.from" />
          до
          <price :value="priceValue.to" />
        </template>
        <template v-else>
          {{ getItemLabel(filter.id) }}
        </template>
      </div>
    </mobile-multiselect-item>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Price from '@/components/price/price.vue';
import { SORT_NAME_MAP, PRICE_FILTER_ID } from '@/store/consts';
import MobileMultiselectItem from '@/components/mobile-multiselect/mobile-multiselect-item.vue';

export default {
  components: { Price, MobileMultiselectItem },

  computed: {
    ...mapState('category', ['sort', 'filters', 'appliedFiltersState']),
    ...mapGetters('category', ['priceFilter']),

    sortTitle() {
      return SORT_NAME_MAP[this.sort];
    },
    priceValue() {
      const appliedPriceFilterValue = this.getFilterValue(PRICE_FILTER_ID);

      if(appliedPriceFilterValue) {
        return appliedPriceFilterValue[0]
      }

      return this.priceFilter.values[0]
    }
  },

  methods: {
    getFilterValue(filterId) {
      const filter = this.appliedFiltersState.find(filter => filter.id === filterId);

      return filter?.value
    },
    getItemLabel(filterId) {
      const filterValue = this.getFilterValue(filterId);

      if (!filterValue?.length) return;

      return filterValue[0]?.label
    },
    isCount(filterId) {
      if(filterId === PRICE_FILTER_ID) return false;

      const filterValue = this.getFilterValue(filterId);

      if(!filterValue) return false;

      return filterValue.length > 1;
    },
    isPrice(filterId) {
      return filterId === PRICE_FILTER_ID;
    },
  },
}
</script>

<style lang="scss">
  .panel-filters {
    &__item {
      &:last-child {
        border: none;
      }
    }

    &__item-value {
      font-size: 14px;
      color: $gray;
      line-height: 24px;

      .price {
        display: inline;
      }
    }
  }
</style>